﻿const dashboardModel = {
    el: 'main',
    data() {
        return {
            cards: {
                gateway: { critical: 0, warning: 0, healthy: 0, unmapped: 0 },
                channel: { critical: 0, warning: 0, healthy: 0 },
                unassignedGateway: { count: 0 },
                levelSensor: { alerts: 0, high: 0, low: 0 },
            },
            tickets: {},
            filters: {
                date: "Last 7 days",
                location: "All Location",
            },
            showDropdown: {
                date: false,
                location: false,
            },
            stats: null,
            activeGateways: null,
        }
    },
    computed: {
        formattedDate() {
            if (!this.stats) return '';
            const d = this.stats.date;
            return `${d.slice(6, 8)}/${d.slice(4, 6)}/${d.slice(0, 4)}`;
        }
    },
    async mounted() {
        const counts = await api.get(api.gateway.counts);
        this.cards.channel = counts[1];
        const gty = await api.get(api.gateway.aged);
        this.cards.gateway.warning = gty.filter(g => g.age >= 45 && g.age < 120).length;
        const unmapped = g => g.age < 0 && g.mapped === false;
        this.cards.gateway.critical = gty.filter(g => g.age >= 120 || (g.age < 0 && !unmapped(g))).length;
        this.cards.gateway.healthy = gty.filter(g => g.age >= 0 && g.age < 45).length;
        this.cards.gateway.unmapped = gty.filter(unmapped).length;
        const unassigned = await api.get("/api/gateway/unassigned/count");
        this.cards.unassignedGateway.count = unassigned.count;
        this.tickets = await api.get(api.ticket.counts);

        if (document.querySelector('[data-summary-cards]')) {
            await Promise.all([this.loadStats(), this.loadActiveGateways()]);
        }
    },
    methods: {
        toggleDropdown(type) {
            this.showDropdown[type] = !this.showDropdown[type];
        },
        selectOption(type, value) {
            this.filters[type] = value;
            this.showDropdown[type] = false;
        },
        async loadStats() {
            this.stats = await window.api.get(window.api.usage.previousDay);
        },
        async loadActiveGateways() {
            const result = await window.api.get(window.api.gateway.activeCount);
            this.activeGateways = result ? result.activeGateways : null;
        }
    }
};
var app = Vue.createApp(dashboardModel);
var vm = app.mount("#app");